

















































































































































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { maskCPFCNPJ, maskDateTime, maskMoney, timeoutDefault } from '@/utils/common'
import { RequestMessage, IRequestMessage } from '@/types/_'
import moment from 'moment'

@Component
export default class ComponentModalProcedimentosDescartados extends Vue {
  getRequestMessage: IRequestMessage = new RequestMessage()
  loadShowModalEmitirRelatorio: boolean = false

  get showModal() { return this.getFinanceiroStore.modal.procedimentosDescartados }
  set showModal(value: boolean) { this.getFinanceiroStore.setModal({ name: 'procedimentosDescartados', value }) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get getPagina() {
    return this.getFinanceiroStore.pagina
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setPagina(value)
  }

  get loadingShowModalEmitirRelatorio() {
    return this.loadShowModalEmitirRelatorio
  }

  set loadingShowModalEmitirRelatorio(value: boolean) {
    this.loadShowModalEmitirRelatorio = value
  }

  get headers() {
    return [
      { text: '', value: '', align: 'left' },
      { text: 'Fonte pagadora', value: 'fontePagadoraNome', align: 'center' },
      { text: 'Prestador', value: 'prestadorNome', align: 'center' },
      { text: 'Profissional', value: 'profissionalExecutanteNome', align: 'center' },
      { text: 'Função', value: 'funcao', align: 'center' },
      { text: 'Código', value: 'codigo', align: 'center' },
      { text: 'Descrição', value: 'descricao', align: 'center' },
      { text: 'Data execução', value: 'dataExecucao', align: 'center' },
      { text: 'Valor faturado', value: 'valorFaturado', align: 'center' },
    ]
  }

  get items() {
    return this.getFinanceiroStore.procedimentosDescartados
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getTotal() {
    return this.getFinanceiroStore.totalProcedimentosDescartados || 0
  }

  get length() {
    return Math.ceil(this.getTotal / this.getFinanceiroStore.qtdPorPagina)
  }

  maskMoneyUtil(value) {
    return maskMoney(value)
  }

  formatDateUtil(date: string) {
    if (['', null, undefined].includes(date)) return 'Não informado'
    return moment(date).format('DD/MM/YYYY')
  }

  async openModalEmitirRelatorio() {
    this.loadingShowModalEmitirRelatorio = true
    this.getFinanceiroStore.setModal({ name: 'emitirRelatorio', value: true })
    this.loadingShowModalEmitirRelatorio = false
  }

  async getResults(pagina: number) {
    const id = this.getFinanceiroStore.idForLoadProcedimentosDescartados
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.getPagina = pagina
    await this.getFinanceiroStore.getProcedimentosDescartados()
    EventBus.$emit('clearLoadingRequest')
  }

  // Advanced-filters
  get drawer() {
    return this.getFinanceiroStore.filterProcedimentosDescartadosDrawer
  }

  set drawer(value: boolean) {
    this.getFinanceiroStore.setFilterProcedimentosDescartadosDrawer(value)
  }

  async showAdvancedFilters() {
    this.drawer = !this.drawer
  }

  async clearAdvancedFilters() {
    this.getFinanceiroStore.clearProcedimentosDescartadosFilter()
    this.getFinanceiroStore.setFilterOn(false)
    await this.getFinanceiroStore.getProcedimentosDescartados()
  }

  @Watch('showModal')
  onChangeModalValidacaoEGeracaoRepasse(value: boolean) {
    if (!value) {
      this.clearAdvancedFilters()
      this.getFinanceiroStore.clearProcedimentos()
      this.getFinanceiroStore.clearTransacaoFinanceira()
      this.getFinanceiroStore.clearCentroDeCusto()
      this.getFinanceiroStore.clearProfissionaisExecutantes()
      this.getFinanceiroStore.clearMotivosInclusao()
      this.getFinanceiroStore.clearPagePagination()
      this.getFinanceiroStore.clearItensDeRepasseSelecionados()
    }
  }
}
